import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Tag } from 'src/app/models/services/tag';
import { AudiencesListFilter } from 'src/app/models/ui/audiencesListFilter';

@Component({
  selector: 'app-transfers-list-filter-dialog',
  templateUrl: './transfers-list-filter-dialog.component.html',
  styleUrls: ['./transfers-list-filter-dialog.component.sass']
})
export class TransfersListFilterDialogComponent implements OnInit {
  public accept: () => void;
  public dismiss: () => void;
  public filter: AudiencesListFilter;
  public textSearchFormControl: FormControl = new FormControl();

  constructor() { }

  ngOnInit(): void {
    this.textSearchFormControl.setValue(this.filter.textSearch);
  }

  onAcceptClick = (): void  => {   
    this.filter.textSearch = this.textSearchFormControl.value;
    this.accept();
  }  

  onResetFilterClick = (): void  => {   
    this.textSearchFormControl.setValue("");
  }  
}


